module.exports = __webpack_public_path__ + "static/media/temperature-low.7ede5107.svg";